import { FC } from 'react';
import { Content } from '@prismicio/client';
import { DataModalProps } from '@/types';
import {
  ModalSlicePrivacyPolicyPrimary,
  Simplify,
} from '../../../../../prismicio-types';
import {
  FourColumnsTable,
  InstructionList,
  TermsServiceHeroInner,
  ThreeColumnsTable,
} from '@/components';

import { List } from './parts';

import styles from './PrivacyPolicyModal.module.scss';

type ListType =
  Simplify<Content.TermsInstrictionSliceDefaultPrimaryInstructionItem>[];

export const PrivacyPolicyModal: FC<
  DataModalProps<ModalSlicePrivacyPolicyPrimary>
> = ({ data }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.hero}>
        <TermsServiceHeroInner
          data={{
            last_update_text: data.last_update_text,
            last_update_value: data.last_update_value,
            description: data.description,
            title: data.title,
          }}
          variant="modal"
        />
      </div>
      <div className={styles.list1}>
        <List list={data.list_1} />
      </div>
      <div className={styles.table1}>
        <FourColumnsTable
          data={{ head: data.head_1, body: data.body_1 }}
          variant="modal"
        />
      </div>
      <div className={styles.listWithoutTitle}>
        <InstructionList
          list={data.list_without_title as ListType}
          variation="defaultWithoutTitle"
        />
      </div>
      <div className={styles.table2}>
        <ThreeColumnsTable
          data={{ head: data.head_2, body: data.body_2 }}
          variant="modal"
        />
      </div>
      <div className="">
        <List list={data.list_2} />
      </div>
    </div>
  );
};
